<template>
  <div v-if="courseId && preparationStage">

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar
          :color="$vuetify.theme.dark ? '#1e1e1e' : '#ffffff'"
          class="elevation-0"
        >
          <h3 v-if="!isMobile()">Guia de estudos</h3>
          <v-app-bar-nav-icon
            v-if="isMobile()"
            @click="chatsMenu = !chatsMenu"
          ></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-navigation-drawer
          v-model="chatsMenu"
          app
          clipped
          floating
          width="205"
          :color="$vuetify.theme.dark ? '#1e1e1e' : '#ffffff'"
        >
          <h3 v-if="isMobile()" class="pt-4 pl-5">Guia de estudos</h3>
          <v-list dense rounded style="padding-left: 16px; padding-top: 25%">
            <v-list-item
              v-for="guide in guides"
              :key="guide.id"
              :input-value="selectedGuideId === guide.id"
              color="primary"
              @click="switchGuide(guide)"
            >
              <v-list-item-content>
                <v-list-item-title
                  style="font-size: 0.875rem !important; text-wrap: auto"
                >
                  {{ guide.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>

        <div class="chat-container">
          <transition name="slide-fade-out">
            <div v-if="guideGenerated === false || animationIsWorking === true">
              <TypingEffect
                :text="`Olá, ${getFirstName($store.state.auth.user.name)}!`"
                class="greeting"
                :startDelay="500"
              />
              <br />
              <TypingEffect
                :text="'Estou gerando um guia de estudos com base no seu comportamento na plataforma'"
                class="greeting"
                :startDelay="2500"
              />
              <TypingEffect
                :text="'...'"
                :loop="true"
                :speed="275"
                class="greeting reticencias"
                :startDelay="8700"
              />
            </div>
          </transition>

          <transition-group name="slide-fade-in" tag="div">
            <div
              v-if="animationMinDuration"
              v-for="message in learningGuideMessages"
              :key="message.id"
              class="chat-message"
              :class="{ 'chat-message--sent': message.user === 'you' }"
            >
              <v-avatar>
                <template>
                  <img
                    v-if="message.user === 'tutor'"
                    src="/favicon-32x32.png"
                    alt="Tutor Avatar"
                  />
                  <img
                    v-else
                    :src="$store.state.auth.user.avatar"
                    alt="User Avatar"
                  />
                </template>
              </v-avatar>
              <div
                class="chat-message-text"
                :class="{ 'chat-message-text--dark': $vuetify.theme.dark }"
                v-html="compiledMarkdown(message.body)"
              ></div>
            </div>
          </transition-group>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import TutorService from "../../services/tutor.service";
import TypingEffect from "../animation/TypingEffect.vue";
import UsersService from "../../services/users.service";
import ChatDialog from "../chat/ChatDialog.vue";

export default {
  name: "LearningGuideDialog",
  components: {
    TypingEffect,
    ChatDialog,
  },
  props: {
    courseId: Number,
    preparationStage: Number,
  },
  data() {
    return {
      dialog: false,
      ready: false,
      animationIsWorking: false,
      showBtnUpdateGuide: false,
      selectedGuideId: null,
      learningGuideMessages: [],
      learningGuideMessagesControl: new Set(),
      chatsMenu: false,
      guides: [],
      guideGenerated: false,
      animationMinDuration: false,
      showChat: false,
      animationTimeoutId: null
    };
  },
  mounted() {
    this.hasGuide();
    
  },
  methods: {
    registerMenuOptions() {

      console.log('>>> registerMenuOptions')
      console.log(">>> ready", this.ready);
      if (this.ready === false) {
        this.$emit('register-options', []);
        return;
      }

      const options = [
        {
          label: this.guideGenerated
            ? "Consultar guia de estudos"
            : "Gerar guia de estudos",
          component: "learningGuide",
          action: "guideClicked",
          order: 2,
        },
      ];

      console.log(">>> options dentro do compoenente", options);
      console.log(">>> this.guideGenerated", this.guideGenerated);
      console.log(">>> showBtnUpdateGuide", this.showBtnUpdateGuide);
      if (this.showBtnUpdateGuide) {
        options.push({
          label: "Gerar novo guia de estudos",
          component: 'learningGuide',
          action: 'updateGuide',
          order: 1
        });
      }

      this.$emit('register-options', options);
    },
    async hasGuide() {
      try {
        const databaseGuides = await UsersService.getUserLeaningGuides(
          this.courseId,
          this.preparationStage,
        );

        let currentGuideSetted = false;
        for (const [index, guide] of databaseGuides.data.entries()) {
          if (guide.is_generated) {
            this.guides.push({
              id: guide.id,
              title: `${guide.title} (${guide.generated_at})`,
              body: guide.body,
            });

            if (currentGuideSetted === false) {
              if (guide.is_out_dated) {
                this.showBtnUpdateGuide = true;
              }
              currentGuideSetted = true;
              await this.switchGuide(guide);
              this.animationMinDuration = true;
            }
          }
        }
        this.ready = true;
        this.registerMenuOptions();
        console.log(">>> terminou hasguide", this.ready);
      } catch (error) {
        console.log("didnt found guide on mounted:", error);
        if (error.response && error.response.status === 404) {
          this.ready = true;
        }
      }
    },
    async askLearningGuide() {
      this.dialog = true;
      this.startAnimationMinDurationTimer();
      try {
        const processingGuide = await TutorService.askGuide(this.courseId, this.preparationStage);
        this.checkGuideStatus(processingGuide);
      } catch (error) {
        console.log(error)
        this.dialog = false;
        this.stopAnimationMinDurationTimer();
        if (error.isValidationError()) {
          window.getApp.sendSnackMessage(error.message, 'error');
        }
      }
    },

    async checkGuideStatus(processingGuide) {
      const guideResponse = await TutorService.getGuide(
        processingGuide.data.id,
      );

      if (guideResponse.status === 202) {
        const _this = this;
        setTimeout(function () {
          _this.checkGuideStatus(processingGuide);
        }, 2000);
      } else {
        const guide = guideResponse.data.data;
        if (guide.is_generated) {
          this.guides.unshift({
            id: guide.id,
            title: `${guide.title} (${guide.generated_at})`,
            body: guide.body,
          });
          await this.switchGuide(guideResponse.data.data);
          this.showBtnUpdateGuide = false;
        }
      }
    },

    addMessageToChat(message) {
      if (this.learningGuideMessagesControl.has(message.id)) {
        return;
      }
      this.learningGuideMessagesControl.add(message.id);
      this.learningGuideMessages.push(message);
      this.guideGenerated = true;
    },
    startAnimationMinDurationTimer() {
      this.animationIsWorking = true;
      this.animationTimeoutId = setTimeout(() => {
        this.animationMinDuration = true;
        this.animationIsWorking = false;
      }, 10000);
    },

    stopAnimationMinDurationTimer() {
      if (this.animationTimeoutId) {
        clearTimeout(this.animationTimeoutId);
      }
      this.animationIsWorking = false;
      this.animationMinDuration = false;
    },

    compiledMarkdown(text) {
      const md = new MarkdownIt();
      const defaultRender =
        md.renderer.rules.link_open ||
        function (tokens, idx, options, env, self) {
          return self.renderToken(tokens, idx, options);
        };

      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const token = tokens[idx];
        const aIndex = token.attrIndex("target");
        if (aIndex < 0) {
          token.attrPush(["target", "_blank"]);
        } else {
          token.attrs[aIndex][1] = "_blank";
        }
        return defaultRender(tokens, idx, options, env, self);
      };

      return md.render(text);
    },
    getFirstName(name) {
      return name.split(" ")[0];
    },
    guideClicked() {
      this.isMobile() ? (this.chatsMenu = false) : (this.chatsMenu = true);
      if (this.guideGenerated) {
        this.dialog = true;
      } else {
        this.askLearningGuide();
      }
    },
    updateGuide() {
      this.learningGuideMessages = [];
      this.learningGuideMessagesControl.clear();
      this.dialog = true;
      this.guideGenerated = false;
      this.animationMinDuration = false;
      this.isMobile() ? (this.chatsMenu = false) : (this.chatsMenu = true);
      this.askLearningGuide();
    },
    async switchGuide(guide) {
      try {
        this.guideGenerated = true;
        this.learningGuideMessages = [
          {
            id: guide.id,
            user: "tutor",
            body: guide.body,
          },
        ];
        this.learningGuideMessagesControl.clear();
        this.learningGuideMessagesControl.add(guide.id);
        this.selectedGuideId = guide.id;
        console.log("Selected Guide Data:", guide);
      } catch (error) {
        console.error("Failed to open the guide:", error);
      }
    },

    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>

<style lang="scss" scoped>
.div-fixed {
  position: fixed;
  bottom: 5%;
  right: 2%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;

  .text-div-fixed {
    background: -webkit-linear-gradient(
      75deg,
      var(--v-primary-lighten2),
      var(--v-primary-lighten3)
    );
    border-radius: 9999px;
    padding: 3px 25px;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
}

.svg-icon {
  width: 35px;
  height: 30px;
}

.btn-guia-estudos {
  background: -webkit-linear-gradient(
    58deg,
    var(--v-primary-base),
    var(--v-primary-lighten3)
  );
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 5%;
}

.chat-container {
  max-width: 800px;
  margin: 5% auto 0;
  padding-bottom: 20px;
  @media (max-width: 887px) {
    margin: 5% 5% 0;
  }
}

.chat-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 10px;
  @media (max-width: 587px) {
    flex-direction: column;
  }
}

.chat-message-text {
  font-size: 18px;
  line-height: 1.75;
  padding: 22px 30px;
  background-color: #f0f0f0;
  border-radius: 16px;
}

.chat-message-text--dark {
  background-color: #000000;
}

.greeting {
  font-size: 52px;
  color: darkblue;
  background: -webkit-linear-gradient(
    45deg,
    var(--v-primary-base),
    var(--v-primary-lighten2)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 390px) {
    font-size: 40px;
  }
}

.reticencias {
  @extend .greeting;
  letter-spacing: 5px;
}

.slide-fade-out-enter-active,
.slide-fade-out-leave-active {
  transition:
    opacity 1s ease,
    transform 1s ease;
}

.slide-fade-out-leave-to {
  opacity: 0;
  transform: translateX(-150px);
}

.slide-fade-in-enter-active,
.slide-fade-in-leave-active {
  transition:
    opacity 1s ease,
    transform 1s ease;
}

.slide-fade-in-enter-active {
  transition-delay: 0.9s;
}

.slide-fade-in-enter {
  opacity: 0;
  transform: translateX(80px);
}
.v-list-item.active {
  background-color: var(--v-primary-lighten4);
  border-left: 4px solid var(--v-primary-base);
}
</style>
